// / @flow
import * as React from 'react'
import styled, { css } from 'styled-components'
import { classnames } from '@/helpers'
import styles from './styles.scss'

const RIGHT = 'right'
const LEFT = 'left'
const CENTER = 'center'

type HeroProps = {|
  ariaLabel: string,
  imageUrl: string,
  titleText?: string,
  titleStyle?: ?Object,
  subTitleText?: string,
  subTitleStyle?: ?Object,
  children?: React.Node,
  align?: typeof RIGHT | typeof LEFT | typeof CENTER,
  backgroundPosition?: string,
  className?: string,
  short?: boolean,
  textBackgroundColor?: boolean,
|}

const StyledHero = styled.div`
  align-items: center;
  justify-content: center;
  ${props =>
    props.imageUrl &&
    css`
    background: url('${props.imageUrl}');
  `}
  ${props =>
    props.imageUrl &&
    props.textBackgroundColor &&
    css`
      background:
        linear-gradient(
          ${styles.tealBackground},
          ${styles.tealBackground}
        ),
        url('${props.imageUrl}');
    `}
  ${props =>
    props.short &&
    css`
      max-height: 422px;
    `}
    ${props =>
      props.backgroundPosition &&
      css`
        background-position: ${props.backgroundPosition};
      `}
`

const PositionDiv = styled.div`
  align-items: center;
  justify-content: center;
  ${props =>
    props.align === LEFT &&
    css`
      align-items: flex-start;
      justify-content: flex-start;
    `}
  ${props =>
    props.align === RIGHT &&
    css`
      align-items: flex-end;
      justify-content: flex-end;
      @media screen and (max-width: ${styles.mobile}) {
        align-items: flex-start;
        justify-content: flex-start;
      }
    `}
    ${props =>
      props.align === CENTER &&
      css`
        h2 {
          text-align: center;
        }
      `}
`

const DefaultTextDiv = styled.div`
  display: none;
  ${props =>
    props.textBackgroundColor &&
    css`
      padding: ${styles.paddingVertical};
    `}
  ${props =>
    props.titleLength > 29 &&
    css`
      h1 {
        font-size: ${styles.mediumLargeFont};
      }
      @media (min-width: ${styles.tabletMin}) {
        h1 {
          font-size: ${styles.largeFont} !important;
        }
      }

      @media (min-width: ${styles.desktopMin}) {
        h1 {
          font-size: ${styles.extraLargeFont} !important;
        }
      }
    `}
  ${props =>
    props.titleLength > 0 &&
    css`
      display: block;
    `}
`

const Hero = (props: HeroProps) => {
  const {
    className,
    imageUrl,
    titleText,
    subTitleText,
    titleStyle,
    subTitleStyle,
    children,
    textBackgroundColor,
    ...rest
  } = props
  const renderChildren = childs => {
    if (childs) {
      return <div className={styles.children}>{childs}</div>
    }
    return null
  }
  return (
    <div className={styles.headerParent}>
      <StyledHero
        imageUrl={imageUrl}
        className={classnames(styles.headerImage, className)}
        textBackgroundColor={textBackgroundColor}
        {...rest}
      >
        <PositionDiv {...rest} className={styles.maxContentWidth}>
          <DefaultTextDiv
            titleLength={titleText?.length}
            textBackgroundColor={textBackgroundColor}
            className={styles.defaultText}
          >
            <h1 style={titleStyle}>{titleText}</h1>
            <h2 style={subTitleStyle}>{subTitleText}</h2>
          </DefaultTextDiv>
          {renderChildren(children)}
        </PositionDiv>
      </StyledHero>
    </div>
  )
}

Hero.defaultProps = {
  className: '',
  titleText: '',
  subTitleText: '',
  titleStyle: null,
  subTitleStyle: null,
  children: null,
  align: CENTER,
  backgroundPosition: 'center',
  short: false,
  textBackgroundColor: false,
}

export default Hero
